import 'uni-pages';
import Vue from 'vue'
import Page from './pages/index/test.vue'
createPage(Page)